import { useTranslations } from '@vocab/react';

import { Status } from '../Status/Status';

import translations from './.vocab';

export const AvailabilityStatus = ({
  label,
  availability,
}: {
  label: string;
  availability: string;
}) => {
  const { t } = useTranslations(translations);

  const availabilityText =
    {
      '-': '-',
      NOW: t('NOW'),
    }[availability] || t('NOTICE_PERIOD', { weeksFormatted: availability });

  return <Status label={label} text={availabilityText} />;
};
